/**
 * What the master-data forms call their fields.
 *
 * A refused save names the fields it is waiting for. The name comes from
 * `app.label.<field>` and falls back to the field itself where there is no
 * such entry — which is how "Details: glnNumber" reached a user (#2212,
 * R-145). Checked across all three masks: of the fields their schemas can
 * refuse, these are the ones without an entry of their own.
 *
 * Each id is the one the mask already puts above the input, so the message
 * and the form say the same word. A mask whose field means something of its
 * own (a supplier's `name` is "Firmenname", a person's is not) overrides it
 * where it saves.
 */
export const PALO_MASTER_DATA_LABELS: Record<string, string> = {
    addresses: 'app.common.address',
    emails: 'app.label.email',
    ftpPassword: 'app.contactsAndOrganizations.detail.sftp.actualPassword',
    glnNumber: 'app.label.gln',
    mainEmail: 'app.label.email',
    newFtpPassword: 'app.contactsAndOrganizations.detail.sftp.changeFtpPassword',
    phones: 'app.common.phone',
};
